import { Component, type ErrorInfo, type ReactNode } from 'react';
import { T } from '../i18n';

/**
 * Le filet de sécurité.
 *
 * Sans lui, la moindre erreur pendant un rendu — une clé mal orthographiée, une
 * donnée inattendue — démonte toute l'application et l'utilisateur se retrouve
 * devant une PAGE BLANCHE. Pas un message : du blanc. C'est exactement ce qui
 * s'est produit sur l'écran Analytique avec une clé accentuée par erreur.
 *
 * Une page blanche fait croire que les données sont perdues. Elles ne le sont
 * jamais : rien n'est écrit côté serveur pendant un rendu.
 */
interface Props { children: ReactNode }
interface State { erreur: Error | null }

export class Filet extends Component<Props, State> {
  state: State = { erreur: null };

  static getDerivedStateFromError(erreur: Error): State {
    return { erreur };
  }

  componentDidCatch(erreur: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[écran] rendu impossible —', erreur, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.erreur) return this.props.children;
    return (
      <div style={{ maxWidth: 560, margin: '48px auto', padding: '0 20px' }}>
        <div className="carte carte-p">
          <h2 style={{ marginBottom: 8 }}>{T.filet.titre}</h2>
          <p style={{ color: 'var(--texte2)' }}>
            <b>{T.filet.pasPerdues}</b>{T.filet.rienModifie}
          </p>
          <p style={{ color: 'var(--texte2)', marginTop: 10 }}>
            {T.filet.continuer}
          </p>
          <div className="actions" style={{ marginTop: 16 }}>
            <button className="btn btn-p" onClick={() => { window.location.href = '/'; }}>
              {T.filet.revenir}
            </button>
            <button className="btn" onClick={() => window.location.reload()}>{T.filet.reessayer}</button>
          </div>
          <details style={{ marginTop: 14 }}>
            <summary className="mini sourdine" style={{ cursor: 'pointer' }}>{T.filet.detail}</summary>

            <pre style={{ fontSize: 12, whiteSpace: 'pre-wrap', color: 'var(--texte3)', marginTop: 8 }}>
              {this.state.erreur.message}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}
